// extracted by mini-css-extract-plugin
export default {"picture":"ProfilePictureNote__picture___o5uOO"};